import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'semantic-ui-react';
import i18next from 'i18next';

export const WeatherSettings = (props) => {
    const { settings, handleSettingsUpdate } = props;

    return (
        <Form className="settings">
                <Form.Field>
                    <label>{i18next.t('smartPromotions.weather.settings.hotWeatherLabel')}</label>
                </Form.Field>
                <div style={{ display: 'flex' }}>
                    <Input placeholder={i18next.t('smartPromotions.weather.settings.from')}
                        value={settings.hotWeather.from} 
                        onChange={(e, { value }) => handleSettingsUpdate({ ...settings, hotWeather: { ...settings.hotWeather, from: value }})}
                    />
                    <Input placeholder={i18next.t('smartPromotions.weather.settings.to')}
                        value={settings.hotWeather.to} 
                        onChange={(e, { value }) => handleSettingsUpdate({ ...settings, hotWeather: { ...settings.hotWeather, to: value }})}
                    />
                </div>

                <Form.Field>
                    <label>{i18next.t('smartPromotions.weather.settings.coldWeatherLabel')}</label>
                </Form.Field>
                <div style={{ display: 'flex' }}>
                    <Input placeholder={i18next.t('smartPromotions.weather.settings.from')}
                        value={settings.coldWeather.from} 
                        onChange={(e, { value }) => handleSettingsUpdate({ ...settings, coldWeather: { ...settings.coldWeather, from: value }})}
                    />
                    <Input placeholder={i18next.t('smartPromotions.weather.settings.to')}
                        value={settings.coldWeather.to} 
                        onChange={(e, { value }) => handleSettingsUpdate({ ...settings, coldWeather: { ...settings.coldWeather, to: value }})}
                    />
                </div>
            </Form>
    );
};

WeatherSettings.propTypes = {
    
    handleSettingsUpdate: PropTypes.func,
    settings: PropTypes.object
};